export enum OverflowErrorsEnum {
  PayrollCheckUpload001 = "PayrollCheckUpload001",
  PayrollCheckUpload002 = "PayrollCheckUpload002",
  PayrollCheckUpload003 = "PayrollCheckUpload003",
  BucketFile001 = "BucketFile001",
  BucketFile002 = "BucketFile002",
  PayerPlatform02 = "PayerPlatform02",

  EXCEEDED_MAXIMUM_NUMBER_ATTEMPTS_CUSTOMER = "EXCEEDED_MAXIMUM_NUMBER_ATTEMPTS_CUSTOMER",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
}
